import { lazy } from 'react';
import Loadable from 'ui-component/Loadable';
import type { RouteObject } from 'react-router-dom';

const QuotesPage = Loadable(lazy(() => import('./components/QuotesPage')));

/**
 * This feature's own routes, composed into the app router by whichever legacy route file
 * still owns this path prefix — src/routes/AuthenticatedRoutes.jsx today, src/app/router.tsx
 * once that exists (AGENTS.md §1). Mirrors features/shipments/routes.tsx.
 */
export const quotesRoutes: RouteObject[] = [
  {
    path: '/shipments/:shipmentId/quotes',
    element: <QuotesPage />
  }
];
